import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetOrderOptionsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "customer_options": {
                    "code_options": [1, 2],
                    "business_name_options": ["Business Name", "Another Business Name"],
                    "fantasy_name_options": ["Fantasy Name", "Another Fantasy Name"],
                },
                "delivery_site_options": {
                    "name_options": ["Name", "Another Name"],
                    "address_options": ["Address", "Another Address"],
                    "city_options": ["City", "Another City"],
                    "code_options": ["001", "002"],
                },
            },
            errors: []
        }
    }

    customerOptions() {
        const customerOptions = this.content().customer_options;
        return {
            code: customerOptions.code_options,
            businessName: customerOptions.business_name_options,
            fantasyName: customerOptions.fantasy_name_options,
        }
    }

    deliverySiteOptions() {
        const deliverySiteOptions = this.content().delivery_site_options;
        return {
            deliverySiteName: deliverySiteOptions.name_options,
            deliverySiteAddress: deliverySiteOptions.address_options,
            deliverySiteCity: deliverySiteOptions.city_options,
            deliverySiteCode: deliverySiteOptions.code_options,
        }
    }
}